import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { easeOut, prefersReducedMotion } from '@atlaskit/motion';
import { BANNER_HEIGHT, COLLAPSED_LEFT_SIDEBAR_WIDTH, DEFAULT_LEFT_SIDEBAR_FLYOUT_WIDTH, IS_SIDEBAR_COLLAPSING, IS_SIDEBAR_DRAGGING, LEFT_PANEL_WIDTH, LEFT_SIDEBAR_FLYOUT_WIDTH, LEFT_SIDEBAR_WIDTH, RESIZE_BUTTON_SELECTOR, TOP_NAVIGATION_HEIGHT, TRANSITION_DURATION, VAR_LEFT_SIDEBAR_FLYOUT } from '../../common/constants';
import { getPageLayoutSlotCSSSelector } from '../../common/utils';
import { focusStyles } from './styles'; // This inner wrapper is required to allow the
// sidebar to be position: fixed. If we were to apply position: fixed
// to the outer wrapper, it will be popped out of it's flex container
// and Main would stretch to occupy all the space.

export var fixedLeftSidebarInnerStyles = function fixedLeftSidebarInnerStyles(isFixed, isFlyoutOpen, isLeftSidebarCollapsed) {
  return _objectSpread(_objectSpread(_objectSpread({}, focusStyles), isFixed ? _objectSpread(_defineProperty({
    position: 'fixed',
    top: "calc(".concat(BANNER_HEIGHT, " + ").concat(TOP_NAVIGATION_HEIGHT, ")"),
    left: "".concat(LEFT_PANEL_WIDTH),
    bottom: 0,
    width: "".concat(LEFT_SIDEBAR_WIDTH),
    transition: "width ".concat(TRANSITION_DURATION, "ms ").concat(easeOut, " 0s")
  }, "[".concat(IS_SIDEBAR_DRAGGING, "] &"), {
    // Make sure drag to resize does not animate as the user drags
    transition: 'none',
    cursor: 'ew-resize'
  }), isFlyoutOpen && {
    width: LEFT_SIDEBAR_FLYOUT_WIDTH
  }) : {
    height: '100%'
  }), prefersReducedMotion());
};
export var leftSidebarStyles = function leftSidebarStyles(isFixed, isFlyoutOpen) {
  var _objectSpread3;

  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread((_objectSpread3 = {
    position: 'relative',
    width: "".concat(LEFT_SIDEBAR_WIDTH),
    transition: "width ".concat(TRANSITION_DURATION, "ms ").concat(easeOut, " 0s"),
    zIndex: 1,
    // Make resize affordance appear on top of content
    marginLeft: 0
  }, _defineProperty(_objectSpread3, "[".concat(IS_SIDEBAR_DRAGGING, "] &"), {
    // Make sure drag to resize does not animate as the user drags
    transition: 'none',
    cursor: 'ew-resize'
  }), _defineProperty(_objectSpread3, "&:hover [".concat(RESIZE_BUTTON_SELECTOR, "]"), {
    opacity: 1
  }), _objectSpread3), isFlyoutOpen && {
    width: LEFT_SIDEBAR_FLYOUT_WIDTH
  }), isFlyoutOpen && !isFixed && _defineProperty({}, "& + ".concat(getPageLayoutSlotCSSSelector('main')), {
    // adds a negative left margin to main
    // which transitions at the same speed
    // with which left sidebars width increases
    // This give an illusion that the flyout is appearing
    // on top of the main content, while main remains in place
    marginLeft: "calc(-1 * var(--".concat(VAR_LEFT_SIDEBAR_FLYOUT, ", ").concat(DEFAULT_LEFT_SIDEBAR_FLYOUT_WIDTH, "px) + ").concat(COLLAPSED_LEFT_SIDEBAR_WIDTH, "px)")
  })), isFixed && _objectSpread({
    // in fixed mode this element's child is taken out of the document flow
    // It doesn't take up the width as expected
    // psuedo element forces it to take up the necessary width
    '&::after': {
      content: "''",
      display: 'inline-block',
      width: "".concat(LEFT_SIDEBAR_WIDTH)
    }
  }, isFlyoutOpen && {
    width: COLLAPSED_LEFT_SIDEBAR_WIDTH
  })), focusStyles), prefersReducedMotion());
};
export var resizeableChildrenWrapperStyle = function resizeableChildrenWrapperStyle(isFlyoutOpen, isLeftSidebarCollapsed, collapsedState) {
  return _objectSpread(_defineProperty({
    visibility: 'visible',
    transition: 'none',
    opacity: 1,
    overflow: 'hidden auto',
    height: '100%'
  }, "[".concat(IS_SIDEBAR_COLLAPSING, "] &"), hideLeftSidebarContents), (isLeftSidebarCollapsed || collapsedState) && !isFlyoutOpen && hideLeftSidebarContents);
};

var hideLeftSidebarContents = _objectSpread({
  // the transition duration is intentionally set to 0ms
  // transition is being used here to delay the setting of
  // opacity and visibility so that it syncs collapsing sidebar.
  transition: "opacity 0ms linear, visibility 0ms linear",
  transitionDelay: "".concat(TRANSITION_DURATION - 100, "ms"),
  opacity: 0,
  visibility: 'hidden'
}, prefersReducedMotion());

export var fixedChildrenWrapperStyle = {
  height: '100%',
  minWidth: '240px'
};